export enum SLOTS_WITH_FALLBACK_ENUM {
    banner = 'banner',
    rectangle = 'rectangle',
    topmobile = 'topmobile',
    teaser = 'teaser',
    mobile_teaser = 'mobile_teaser',
}
export interface AdDetails {
    url: string
    rectangle: string
    banner: string
    topmobile: string
    androidLink?: string
    iOSLink?: string
}

const fallbacksHrefs = {
    dopaOnTour: 'https://www.printyourticket.de/Tour/DOPPELPASS-11559.html',
    bayernNewsletter: 'https://www.sport1.de/news/unternehmen/2025/10/fc-bayern-newsletter',
    bvbNewsletter: 'https://www.sport1.de/news/unternehmen/2025/10/bvb-newsletter',
    dartsNewsletter2023:
        'https://www.sport1.de/news/unternehmen/2023/08/newsletter-anmeldungen-2023',
    dartsNewsletter2022: 'https://www.sport1.de/news/unternehmen/2022/11/newsletter-anmeldung',
    sport1AppAndroid:
        'https://play.google.com/store/apps/details?id=sport1.mobile.android.apps&hl=de',
    sport1AppIos: 'https://apps.apple.com/de/app/sport1-sport-fussball-news/id300000385',
    motorsport: 'https://www.sport1.de/news/motorsport/2025/11/motorsport-newsletter',
    football: 'https://www.sport1.de/news/internationaler-fussball/2025/11/fussball-newsletter',
    usSport: 'https://www.sport1.de/news/us-sport/2025/11/us-sport-newsletter',
}

const fallbackSizes = {
    [SLOTS_WITH_FALLBACK_ENUM.rectangle]: { width: '300px', height: '250px' },
    [SLOTS_WITH_FALLBACK_ENUM.topmobile]: { width: '320px', height: '50px' },
    [SLOTS_WITH_FALLBACK_ENUM.banner]: { width: '728px', height: '90px' },
}

const adFallbacks: AdDetails[] = [
    {
        url: fallbacksHrefs.dopaOnTour,
        rectangle: 'https://reshape.sport1.de/c/t/a019d153-5137-469a-94b5-3226d14ab1f6/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/db29fa3d-6560-4fe5-a47c-3aac479cc2ec/0x0',
        banner: 'https://reshape.sport1.de/c/t/d8f91972-f9f3-4cfd-942e-1a0c7ae93c9a/0x0',
    },
    {
        url: fallbacksHrefs.bayernNewsletter,
        rectangle: 'https://reshape.sport1.de/c/t/7ee348a3-5a79-4cd4-9c6c-69111f60662d/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/551db826-f388-4db4-8d6e-4a46b5f8844b/0x0',
        banner: 'https://reshape.sport1.de/c/t/e3d80164-4fad-4737-9b44-7b4d84b6e9c2/0x0',
    },
    {
        url: fallbacksHrefs.bvbNewsletter,
        rectangle: 'https://reshape.sport1.de/c/t/74e6193c-9d3b-4ec1-be45-f3187d32259a/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/211c2110-3f08-416b-9dcc-869a89bc8b92/0x0',
        banner: 'https://reshape.sport1.de/c/t/ecc989af-77d8-4618-9e74-4b1a907fd305/0x0',
    },
    {
        url: fallbacksHrefs.dartsNewsletter2023,
        rectangle: 'https://reshape.sport1.de/c/t/e0718312-7761-44e3-b7b4-aa3b417a8df8/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/f2226e0d-27c8-41f1-9ad9-814777aaecb9/0x0',
        banner: 'https://reshape.sport1.de/c/t/cc3ddaaa-ce5b-4765-9877-e734ac7b9168/0x0',
    },
    {
        url: fallbacksHrefs.dartsNewsletter2022,
        rectangle: 'https://reshape.sport1.de/c/t/11832708-a8f6-4183-a7a4-c55adb9e2255/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/02d31626-3a06-46fa-92ea-96ac97084a08/0x0',
        banner: 'https://reshape.sport1.de/c/t/33baa200-790a-49e3-bc21-d6affcf44891/0x0',
    },
    {
        url: '',
        androidLink: fallbacksHrefs.sport1AppAndroid,
        iOSLink: fallbacksHrefs.sport1AppIos,
        rectangle: 'https://reshape.sport1.de/c/t/58abb0fb-0996-484f-9c0d-f3ae1e700803/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/49955f5c-54bd-45fe-a264-3818c07f4d39/0x0',
        banner: 'https://reshape.sport1.de/c/t/e020c99e-c265-46fb-a54f-e534a49a741b/0x0',
    },
    {
        url: '',
        androidLink: fallbacksHrefs.sport1AppAndroid,
        iOSLink: fallbacksHrefs.sport1AppIos,
        rectangle: 'https://reshape.sport1.de/c/t/cd5cb91c-7760-4753-be07-f6dc51b3b4f0/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/10f716f3-f7c0-4b7a-abac-708d11807159/0x0',
        banner: 'https://reshape.sport1.de/c/t/9ddc8a0e-5c2b-4ae3-a6cc-0ba372749225/0x0',
    },
    {
        url: fallbacksHrefs.bvbNewsletter,
        rectangle: 'https://reshape.sport1.de/c/t/74e6193c-9d3b-4ec1-be45-f3187d32259a/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/211c2110-3f08-416b-9dcc-869a89bc8b92/0x0',
        banner: 'https://reshape.sport1.de/c/t/ecc989af-77d8-4618-9e74-4b1a907fd305/0x0',
    },
    {
        url: fallbacksHrefs.motorsport,
        rectangle: 'https://reshape.sport1.de/c/t/7c68b789-67fd-46b4-a949-4df3f2e09b66/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/c0b05e0c-7da2-442f-bc5e-8863c2a5e4ec/0x0',
        banner: 'https://reshape.sport1.de/c/t/e15af79e-2214-4d7a-a70d-19eeb9b1c24c/0x0',
    },
    {
        url: fallbacksHrefs.football,
        rectangle: 'https://reshape.sport1.de/c/t/23007fbe-fe27-42e6-a941-ea9baa955a64/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/6e8a18b2-c991-4d53-9905-c4bde423d061/0x0',
        banner: 'https://reshape.sport1.de/c/t/7a9b7896-1228-4532-890a-2ee468e4d367/0x0',
    },
    {
        url: fallbacksHrefs.usSport,
        rectangle: 'https://reshape.sport1.de/c/t/67becb0c-ad2b-41f8-8366-5407ef6a6124/0x0',
        topmobile: 'https://reshape.sport1.de/c/t/4ad46c6b-c223-4d69-a37e-e948f9cd4d14/0x0',
        banner: 'https://reshape.sport1.de/c/t/b382b5c3-2ce2-4537-a02a-9da00d4bb439/0x0',
    },
]

export { adFallbacks, fallbackSizes }
